import sortBy from 'lodash/sortBy';

import * as API from '../api/CitiesApi';
import parseCities from '../parsers/parseCities';
import { City } from '../schemas/CitySchema';

export async function getCities(): Promise<City[]> {
  const cities = await API.getCities();
  const parsedCities = parseCities(cities);

  return sortBy(parsedCities, ['name']);
}
